import { Injectable } from '@angular/core';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { BehaviorSubject, fromEvent, map, merge, of } from 'rxjs';
import { SyncService } from './modules/sync/sync.service';

@Injectable({ providedIn: 'root' })
export class AppService {
	public networkStatus = new BehaviorSubject<boolean>(false);

	constructor(
		private readonly syncService: SyncService,
		private readonly keycloakService: KeycloakService
	) {
		this.checkNetworkStatus();
		this.setupRefreshToken();
	}

	checkNetworkStatus(): void {
		merge(
			of(null),
			fromEvent(window, 'online'),
			fromEvent(window, 'offline')
		)
			.pipe(map(() => navigator.onLine))
			.subscribe((s) => {
				this.networkStatus.next(s);
				this.syncService.sync(s);
			});
	}

	private setupRefreshToken(): void {
		this.keycloakService.keycloakEvents$.subscribe({
			next: (event) => {
				if (event.type === KeycloakEventType.OnTokenExpired) {
					this.keycloakService.updateToken(60);
				}
			},
		});
	}
}
